<template>
  <div class="index">
    <div v-html="con"></div>
  </div>
</template>


<script>

import qs from "qs";
import axios from "axios";
import config from "../config/config";

export default {
  data() {
    return {
      timeType: 1,
      data: [],
      type: 1,
      num: "",
      num2: "",
      token: "",
      con: "",
    };
  },
  mounted() {
    var url = window.location.href.split("=");
    var num = url.length;
    this.token = url[num - 1];
    this.fetch();
  },
  methods: {
    change(index) {
      this.timeType = index;
      this.fetch();
    },
    fetch() {
      let aaa = qs.stringify({
        title: decodeURI(this.token),
      });

      axios.defaults.headers["Content-type"] =
        "application/x-www-form-urlencoded";
      // axios.defaults.headers["token"] = //this.token;
      //   "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImNhNGUzZGFlLTgyZGUtNGFiNS05NWVmLTM0ZWNlMWJjNjVhZSJ9.cFT2xNJo0RLCiofTSZ9dPmikmuBaAw5zhlFAbCppNuT-GkP7ptkC_s3lSUEAwV5buZTIfoYdI3HQb2yTII1QbA";

      axios
        .post(
          config.url+"api/common/content/searchContent",
          aaa
        )
        .then((res) => {
          console.log(res.data.data, "-=-=-=");
          res.data.data.details = res.data.data.details
            .replace(/<p([\s\w"=\/\.:;]+)((?:(style="[^"]+")))/gi, "<p")
            .replace(/<p>/gi, '<p>')
            .replace(/<pre([\s\w"=\/\.:;]+)/gi,'<p')
            .replace(/<img([\s\w"-=\/\.:;]+)((?:(height="[^"]+")))/gi, "<img$1")
            .replace(/<img([\s\w"-=\/\.:;]+)((?:(width="[^"]+")))/gi, "<img$1")
            .replace(/<img([\s\w"-=\/\.:;]+)((?:(style="[^"]+")))/gi, "<img$1")
            .replace(/<img([\s\w"-=\/\.:;]+)((?:(alt="[^"]+")))/gi, "<img$1")
            .replace(
              /<img([\s\w"-=\/\.:;]+)/gi,
              '<img style="width: 100%;" $1'
            );
          this.con = res.data.data.details;
        });
    },
  },
};
</script>


<style scoped>
.index {
    padding: 10px;
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/article.vue